// endSession: the ONE way a session ends in the browser. Added 2026-10-06.
//
// Login writes two stores: the auth store (in memory) and the tenant store
// (PERSISTED to localStorage as "sview360.tenant": currentTenantId,
// isSuperAdmin, plan, timezone). Logout and session expiry cleared only the
// auth store, and clearTenant() had no caller at all. So a tenant id written on
// SUCCESS outlived the session that earned it. The next user in that browser
// inherited it, and api/client.ts appended it as ?tenant_id= to every request
// (a super-admin was silently switched into the previous user's tenant).
// Second instance in one morning of "persisted on success, never cleared"
// (the first was the saved login slug, see api/auth.ts).
//
// Third instance, and the only one that crosses USERS: the react-query cache.
// It held the last user's responses, including signed live-view URLs, stream
// tokens and presigned recording URLs, for staleTime 30 s (served without a
// refetch) and gcTime 5 min. A second operator on a shared branch workstation
// opening the same camera or recording got the first operator's signed URL
// before any refetch could be refused. That is the branch deployment model.
//
// Every session-ending path calls endSession(): logout, the 401/refresh-failure
// handler, password change. login() calls clearUserScopedState() before every
// attempt, so a FAILED login leaves nothing behind either.
import { queryClient } from "@/lib/queryClient";
import { useAuthStore } from "@/store/auth";
import { useTenantStore } from "@/store/tenant";

/** Clear everything that identifies, scopes or authorises the last user:
 *  the persisted tenant store AND every cached server response. */
export function clearUserScopedState(): void {
  useTenantStore.getState().clearTenant();
  queryClient.clear();
}

export function endSession(): void {
  useAuthStore.getState().clear();
  clearUserScopedState();
}
